import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
const LANGUES = [
  {
    code: 'fr',
    language: 'français',
  },
  {
    code: 'en',
    language: 'anglais',
  },
  {
    code: 'pt',
    language: 'portugal',
  },
  {
    code: 'es',
    language: 'espagnol',
  },
];

const Header = () => {
  const navigate = useNavigate();
  const [activate, setActivate] = useState(false);
  const toggleShowLanguage = () => {
    setActivate(!activate);
  };
  return (
    <div className={`dropdown ${activate && 'is-active'}`}>
      <div className="dropdown-trigger">
        <button
          onClick={() => {
            toggleShowLanguage();
          }}
          className="button"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
        >
          <span className="icon is-small">
            <i className="fas fa-globe" aria-hidden="true"></i>
          </span>
        </button>
      </div>
      <div className="dropdown-menu" id="dropdown-menu" role="menu">
        <div className="">
          {LANGUES.map((language) => {
            return (
              <button
                key={language.code}
                className="dropdown-item button is-light"
                onClick={() => {
                  navigate(`/${language.code}`);
                  toggleShowLanguage();
                }}
              >
                {language.code.toLocaleUpperCase()}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Header;
